// @ts-strict-ignore
import { CmsApiSignUpBlockData } from 'modules/cms/api/types/CmsApiSignUp';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsSignUpBlock } from './CmsSignUpBlock';

export const CmsSignUpBlockMapping: CmsBlockMapping<CmsApiSignUpBlockData> = {
  invariant: [],
  width: CmsBlockWidth.FULL,
  Component: CmsSignUpBlock,
  AmpComponent: null,
};
